  import { useEffect } from 'react';
import { Box, Grid, Typography, Container, Paper } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";



const highlights = [
  {
    title: "Contribution",
    description: " 21% supports the Global I Am Peacekeeper Movement, 79% goes directly to the artist or author. ",
    colorClass: "gradient-blue",
    image: imgUrl.contriIcon,
  },
  {
    title: "Eligibility",
    description: <>
      Any <i> I Am Peacekeeper </i> may submit artworks or publications inspired by the     28 Gems of World Peace.      
      All submissions are reviewed by a central committee  before <br></br> being published. 
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.eligibilityIcon,
  },
  {
    title: "Goal",
    description: "To showcase creativity that uplifts humanity and preserves cultural and literary legacies.",
    colorClass: "gradient-blue",
    image: imgUrl.goalIcon,
  },
  {
    title: "Global reach",
    description: <>
        Works are presented online and at Global events, accessible across continents. 
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.goalReachIcon,
  },
];

const whyItMatters = [
  <>
Provide a platform <br></br> for Artists, Writers <br></br> and Creators  to share values-based works.
  </>,
  <>
 Transform art and writing into vehicles for Justice, Love & Peace. 
  </>,

  <>
  Support creators with a fair revenue share while sustaining the Movement. 
  </>,
  <>
  Build a Global archive of visual and written works aligned with the Gems. 
  </>,
  <>
   Inspire communities through accessible creative works, both physical and digital. 
  </>,
  <>
   	Elevate cultural dialogue across borders through art and publications. 
  </>,
  <>
  Preserve Integrity — Contributions are reviewed and approved by a central committee to ensure they reflect the Gems and stand the test of time. 
  </>
];

const howITWorks = [
  <>
   	Original artworks — paintings, drawings, photography and mixed media. 
  </>,
  <>
   	Limited edition prints — signed and numbered for collectors. 
  </>,

  <>
  Open edition prints — accessible and affordable reproductions. 
  </>,
  <>
   Licensed digital prints — approved for personal display and appreciation.
  </>,
  <>
  Custom digital artworks — commissioned pieces inspired by the Gems. 
  </>,
  // <>
  // Collective decision-making <br></br> ensures no bias <br></br> or favouritism.
  // </>,
  <>
 	Merchandise adaptations — posters, postcards, calendars and stationery. 
  </>,
  <>
   Exhibitions — artworks featured at Global events and Peace Summits. 
  </>,
 
];

const howITWorksPublications = [
  <>
   	Anthologies — curated collections of poetry, stories or art tied to the Gems. 
  </>,
  <>
   	Individual books — authored by members of the Movement. 
  </>,

  <>
  Values-based guides — rooted in the 7 Human Values and 28 Gems.
  </>,
  <>
   	Print editions — available for order directly via the website.
  </>,
  <>
  Digital editions — downloadable eBooks, ePubs and PDFs. 
  </>,
  <>
 Subscription library — curated digital access to peace-aligned works.
  </>,
  <>
 	Launch events — books highlighted at Global Summits, Conclaves.  
  </>,
 
];

const circleCourses = [
  {
    text: (
      <>
        Every artwork and publication carries the seal of the     I Am Peacekeeper Movement.     
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        	Each contribution is linked to at least one of the    28 Gems of World Peace.     
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
     Creators are empowered to share their voices while sustaining the Movement through the    21% : 79% model.     
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Together, we build a lasting cultural and literary legacy for tomorrow’s world. 
      </>
    ),
    colorClass: "gradient-yellow",
  }
];

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const BlockCard = ({  title,
  description,
  colorClass = "gradient-green",
  image, }) => (
  <Paper elevation={3} className="infoCard" style={{height:"170px"}}>
     <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
      {description}
    </Typography>
  </Paper>
);

const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 150,
      height: 150,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const CircleBox = ({
  title,
  description,
  colorClass = "gradient-green",
  image,
}) => (
  <Box
    className={`circleBox ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 4,
      m: "auto",
    }}
  >
    <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="subtitle1" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      {description}
    </Typography>
  </Box>
);


const ArtPublications = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Registration Hero Background Section */}
      <Box
        className="programArtPublicationSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
         
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Registration Main Section */}
      <Box className="" mt={5}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            item
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
            <Typography variant="h1" className="founder-title mainHeading green-title" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
              I Am Peacekeeper 
                Arts and <br></br>I Am Peacekeeper Publications 
            </Typography>
          </Grid>
        </Grid>
      </Box>

                 {/* Top Section UI */}
         <Box className="schoolProgramMainSection topBlockBox topBigBlockBox"  mt={5} >
                      {/* <Typography
                                 variant="h5"
                                 align="center"
                                 fontWeight="bold"
                                 gutterBottom
                                 className="subHeading"
                                 pt={5}
                               >
                                TOP
                               </Typography> */}
                         <Container className="paddingSubContainer">
                                  <Grid container spacing={1} mt={5} mb={2} justifyContent="center" sx={{fontFamily: 'var(--default-font)'}}>
                                    {highlights.map((item, index) => (
                                       <Grid size={{xs: 12, md: 3, sm: 6  }} key={index}>
                                                         <BlockCard title={item.title}
                                          description={item.description}
                                          colorClass={item.colorClass}
                                          image={item.image} 
                                                          />
                                                       </Grid>
                                    ))}
                                  </Grid>
                                </Container>
                     </Box>
              {/* why it matters */}
                <Box mt={5} className="programCardMain corporateMainSection mt-50px mattersMediumCircle">
                                <Typography
                                  variant="h2"
                                  align="center"
                                  fontWeight={400}
                                  gutterBottom
                                  className="subHeading mb-0px"
                                  sx={{ fontFamily: 'var(--heading-font)' }}
                                >
                                  Why It Matters
                                </Typography>
                                {/* <p align="center">
                                  Your organization’s partnership directly supports your Corporate
                                  Social <br></br> Responsibility (CSR) goals
                                </p> */}
                      
                                <Container className="paddingSubContainer programCardContainer mt-30px">
                                  <Grid
                                    container
                                    spacing={2}
                                    mt={1}
                                    justifyContent="center"
                                    alignItems="center"
                                    display="flex"
                                  >
                                    {whyItMatters.map((text, index) => (
                                      <Grid
                                        size={{ xs: 12, md: 3, sm: 4 }}
                                        key={index}
                                        justifyContent="center"
                                        alignItems="center"
                                        display="flex"
                                      >
                                        <ProgramCard text={text} />
                                      </Grid>
                                    ))}
                                  </Grid>
                                </Container>
                              </Box>
                {/* How It Works */}
                               <Box className="schoolProgramMainSection">
                                  <Typography
                                         variant="h2"
                                         align="center"
                                         fontWeight={400}
                                         gutterBottom
                                         mt={5}
                                         className="subHeading mt-50px"
                                         sx={{ fontFamily: 'var(--heading-font)' }}
                                       >
                                        What You Can Share & Receive
                                       </Typography>
                                          <Typography variant="h1" align="center" sx={{ fontSize: '20px', fontFamily: 'var(--heading-font)', fontWeight: 400 }} mt={3} mb={1}>
                                        Arts
                                        </Typography> 
                                  
                              
                                       <Container className="paddingSubContainer">
                                         <Grid container spacing={1} mt={2} mb={2} justifyContent="center">
                                           {howITWorks.map((text, index) => (
                                             <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                               <InfoCard text={text} 
                                                />
                                             </Grid>
                                           ))}
                                         </Grid>
                                       </Container>
                                            <Typography variant="h1" align="center" sx={{ fontSize: '20px', fontFamily: 'var(--heading-font)', fontWeight: 400 }} mt={3} mb={1}>
                                        Publications 
                                        </Typography> 
                                  
                              
                                       <Container className="paddingSubContainer">
                                         <Grid container spacing={1} mt={2} mb={2} justifyContent="center">
                                           {howITWorksPublications.map((text, index) => (
                                             <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                               <InfoCard text={text} 
                                                />
                                             </Grid>
                                           ))}
                                         </Grid>
                                       </Container>
                               </Box>  

                               {/* closing */}
                                <Box
                                                        sx={{
                                                          textAlign: "center",
                                                          borderRadius: 3,
                                                          marginBottom:'70px'
                                                        }}
                                                        mt={5}
                                                        className="TabPaddingContainer TabPaddingMainContainer">
                                                       {/* Title */}
                                                        <Typography
                                                          variant="h2"
                                                          fontWeight={400}
                                                          gutterBottom
                                                          className="subHeading"
                                                          sx={{ fontFamily: 'var(--heading-font)' }}
                                                        >
                                                        Legacy of Justice, Love & Peace
                                                        </Typography>
                                                       <Container className="paddingContainer mt-50px" mb={5}>
                                                          <Grid container spacing={5} justifyContent="center" mb={4}>
                                                            {circleCourses.map(({ text, colorClass }, index) => (
                                                              <Grid size={{ xs: 12, sm: 3, md: 2 }} key={index}>
                                                                <ConclusionCard text={text} colorClass={colorClass} />
                                                              </Grid>
                                                            ))}
                                                          </Grid>
                                                        </Container>
                                                 </Box>     

    </>
  );
};

export default ArtPublications;
